import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex-initial flex-shrink-0 h-8 flex justify-center items-center text-gray-500 font-semibold bg-transparent" }
const _hoisted_2 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timetable_day_column = _resolveComponent("timetable-day-column")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ flexGrow: _ctx.sectionsByColumns.length }),
    class: "h-full border-r last:border-0 border-gray-200 flex-auto flex-shrink-0 flex flex-col"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionsByColumns, (column, index) => {
        return (_openBlock(), _createBlock(_component_timetable_day_column, {
          key: index,
          column: column
        }, null, 8, ["column"]))
      }), 128))
    ])
  ], 4))
}